import commonService from './common-service';

class UserService {
  async getUsers(user) {
    try {
      const response = await commonService.getFromServer('Users', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getCipsUsers(params) {
    let add = 'search='+params.search;
    if(params.id) add = 'id='+params.id
    try {
      const response = await commonService.getFromServer('Users/CipsUsers?'+ add, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getUserProfile() {
    try {
      const response = await commonService.getFromServer('Profile', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }
  async updateUser(params){
    try {
      let response;
      if(params.currentUser){
          response = await commonService.postToServer('Profile', params);
      }else{
          response = await commonService.updateToServer('Users/'+params.userId, params);
      }
      if (response) {
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async updateFacility(params){
    try {
      let response = await commonService.postToServer('Facilities', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async changePassword(params){
    try {
      const response = await commonService.postToServer('ChangePassword', params);
      if (response) {
        response.code=200;
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      return (e);
    }
  }
  async forgotPassword(emailId){
    try {
      const response = await commonService.postToServer('ForgotPassword/'+emailId, "");
      if (response) {
        response.code=200;
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      return (e);
    }
  }
  async resetPassword(params){
    try {
      const response = await commonService.postToServer('ResetPassword/', params);
      if (response) {
        response.code=200;
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      throw new Error(e);
    }
  }
  async getUserById(id){
    try {
      const response = await commonService.getFromServer('Users/'+id, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async updatePayors(params){
    try {
      let response = await commonService.postToServer('Payors', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async updateGrpCodes(params){
    try {
      let response = await commonService.postToServer('PayorGroups', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPayors() {
    try {
      const response = await commonService.getFromServer('Users/FMParentsList', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving payors. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPayorById(uid="") {
    try {
      const response = await commonService.getFromServer('Payors?userId='+uid, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving payors. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }  
  async getGrpsById(uid="") {
    try {
      const response = await commonService.getFromServer('PayorGroups?userId='+uid, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving payors. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async getGroupCodes(params) {
    try {
      const response = await commonService.getFromServer('Users/FMGroupsList?parents='+params);
      if (response) {
        return response;
      } else {
        throw new Error('Error loading carriers');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new UserService();
